import React from 'react';
import { useParams } from 'react-router-dom';

import './styles.css';

const BottoniRichiediInfoPrevDoc = ({ servizio }) => {
  const { servizioID } = useParams();

  return (
    <div className='boxRichiesta'>
      <a title={`${servizioID} - informazioni notarili a Treviso`} href={servizio + '/informazioni'} className='bottoneRichiesta'>Richiedi informazioni</a>
      <a title={`${servizioID} - preventivo notarile a Treviso`} href={servizio + '/preventivo'} className='bottoneRichiesta'>Richiedi preventivo</a>
      {/* <a href={servizio + '/documenti'} className='bottoneRichiestaDoc'>Vai ai documenti occorrenti per la pratica notarile</a> */}
    </div>
  );
}

export default BottoniRichiediInfoPrevDoc;
